import { Badge, type BadgeTone } from "@/components/ui/badge"
import type { SkillCategory } from "@/types/skill"

const TONE: Record<SkillCategory, BadgeTone> = {
  knowledge_source: "gold",
  response_action:  "red",
  routing_logic:    "warning",
  workflow:         "neutral",
  integration:      "neutral",
}

const LABEL: Record<SkillCategory, string> = {
  knowledge_source: "Knowledge",
  response_action:  "Response",
  routing_logic:    "Routing",
  workflow:         "Workflow",
  integration:      "Integration",
}

type Props = { category: SkillCategory }

export function SkillCategoryBadge({ category }: Props) {
  return <Badge tone={TONE[category]}>{LABEL[category]}</Badge>
}
